/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-non-literal-fs-filename */
import {
  IMenuItem,
  ModalContainerService,
  NotificationComponent,
  NotificationType,
} from "@aecom/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit, inject, input, output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContractUserService } from "src/app/api-generated";
import { IPContractUserApplicationRoleCreateItem } from "src/app/api-generated/model/iPContractUserApplicationRoleCreateItem";
import { IPContractUserCreateItem } from "src/app/api-generated/model/iPContractUserCreateItem";
import { TPApplicationRole } from "src/app/api-generated/model/tPApplicationRole";
import { TPContract } from "src/app/api-generated/model/tPContract";
import ContractUserCreateItem from "src/app/models/contractUserCreateItem";
import IContractUserWithUserInfo from "src/app/models/IContractUserWithUserInfo";
import LoadingService from "src/app/services/loading.service";
import LocalApplicationService from "src/app/services/local-application.service";
import LocalApplicationRoleService from "src/app/services/local-applicationRole.service";
import {
  DBUserRole,
  DDCUserRole,
  NoAccess,
  SAUserRole,
  cmodAppId,
  correspondenceAppId,
  rfiAppId,
  submittalAppId,
  transmittalAppId,
} from "src/app/shared/staticValue";
import LocalUserRoleService from "src/app/services/local-userRole.service";
import { getOrganizationRoles } from "src/app/shared/utils";
import RowItem from "../contractUser-summary/table-row";

interface ApplicationDropDown {
  id: string;
  name: string;
  dropdowns: IMenuItem[];
  value: string;
}

@Component({
  selector: "app-contract-manage-user",
  templateUrl: "./contract-manageUser.component.html",
  styleUrls: ["./contract-manageUser.component.css"],
  standalone: false,
})
export default class ContractManageUserComponent implements OnInit {
  private router = inject(Router);
  private applicationService = inject(LocalApplicationService);
  private loadingService = inject(LoadingService);
  private activeModal = inject(ModalContainerService);
  private contractUserService = inject(ContractUserService);
  private applicationRoleService = inject(LocalApplicationRoleService);
  private activatedRoute = inject(ActivatedRoute);
  localUserRoleService = inject(LocalUserRoleService);

  readonly selectedUsers = input<RowItem[]>(undefined);

  @Input() contract: TPContract;

  readonly close = output<void>();

  readonly firstOpen = input<boolean>(undefined);

  readonly firstOpenChange = output<boolean>();

  applicationList: ApplicationDropDown[] = [];

  multipleUsers = false;

  readonly activeSave = input<boolean>(undefined);

  readonly activeSaveChange = output<boolean>();

  private mixed = "Mixed";

  private allContractUsers: IContractUserWithUserInfo[];

  public disabledContract = false;

  roleList: TPApplicationRole[] = [];

  ngOnInit(): void {
    const contractUsers: IContractUserWithUserInfo[] =
      this.activatedRoute.snapshot.data.contractUserData;

    this.multipleUsers = this.selectedUsers().length > 1;
    const allRoles = this.localUserRoleService.getItems();
    const selectedUsersRoles = this.selectedUsers().map((u) => {
      const uRoles = allRoles
        .filter((r) => {
          return r.azureId === u.userId;
        })
        .map((r) => {
          return r.appRole;
        });
      if (uRoles.includes(DBUserRole)) {
        return "db";
      }
      if (uRoles.includes(SAUserRole)) {
        return "sa";
      }
      if (
        uRoles.includes(DDCUserRole) ||
        u.organizations.toLocaleLowerCase() === "ddc"
      ) {
        return "ddc";
      }
      return "ahjv";
    });
    const uniqueUserRoles = [...new Set(selectedUsersRoles)];

    this.roleList = this.applicationRoleService.getItems();

    this.allContractUsers = contractUsers;

    const applications = this.applicationService
      .getItems()
      .filter((app) =>
        this.contract.contract_application
          .map((c) => c.ApplicationId)
          .includes(app.Guid),
      );

    applications.sort((a, b) => a.Order - b.Order);

    this.applicationList = applications.map((a) => {
      const roles = this.roleList.filter(
        (role) => role.ApplicationId === a.Guid,
      );

      return {
        id: a.Guid,
        name: a.Name,
        value: "",
        dropdowns: roles.length
          ? getOrganizationRoles(uniqueUserRoles, roles)
          : [],
      };
    });

    console.log(this.applicationList);

    const appIdToUserKey: Record<string, keyof RowItem> = {
      [rfiAppId]: "rfi",
      [submittalAppId]: "submittal",
      [correspondenceAppId]: "correspondence",
      [transmittalAppId]: "transmittal",
      [cmodAppId]: "cmod",
    };

    this.selectedUsers().forEach((user) => {
      this.applicationList.forEach((application) => {
        let value = "";

        const userKey = appIdToUserKey[application.id];
        if (userKey) {
          const rawValue = user[userKey];

          // Ensure it's a string before trimming
          const userValue =
            typeof rawValue === "string" && rawValue.trim() !== ""
              ? rawValue
              : NoAccess;

          // Find matching dropdown item
          const matchedRole = application.dropdowns.find(
            (item) => item.name === userValue,
          );

          value = matchedRole
            ? matchedRole.id
            : typeof rawValue === "string"
              ? rawValue
              : "";
        }

        // Handle application.value logic
        if (application && application.value === "") {
          application.value = value;
        } else if (
          application.value !== value &&
          application.value !== this.mixed
        ) {
          application.dropdowns.push({
            id: this.mixed,
            name: this.mixed,
            checked: false,
            isUnselectable: true,
          });

          application.value = this.mixed;
        }
      });
    });

    console.log(this.applicationList);
  }

  onSubmit(): void {
    if (!this.activeSave()) {
      return;
    }

    const modalInstance = this.activeModal.open(NotificationComponent);

    modalInstance.instance.title = "Notification";
    modalInstance.instance.body =
      "Are you sure you would like to save the changes?";
    modalInstance.instance.theme = "light";
    this.firstOpenChange.emit(true);

    modalInstance.result.then(async (result) => {
      if (result === 1) {
        this.loadingService.start();

        if (this.disabledContract) {
          const ids = this.selectedUsers().map((user) => {
            return user.id;
          });

          this.contractUserService.removeContractUsers(ids).subscribe(
            () => {
              this.back();
            },
            (error: HttpErrorResponse) => {
              this.errorHandle(error);
            },
          );
        } else {
          const contractUsers: IPContractUserCreateItem[] = [];
          const applicationRoles: IPContractUserApplicationRoleCreateItem[] =
            JSON.parse(
              JSON.stringify(
                this.applicationList.map((app) => {
                  return {
                    ApplicationId: app.id,
                    ApplicationRoleId: app.dropdowns.length
                      ? app.dropdowns.find((d) => d.id === app.value).id
                      : app.value,
                  } as IPContractUserApplicationRoleCreateItem;
                }),
              ),
            );

          console.log("applicationRoles", applicationRoles);
          console.log("allContractUsers", this.allContractUsers);

          this.selectedUsers().forEach((user) => {
            const currentContractUser = this.allContractUsers.find((u) => {
              return u.Guid === user.id;
            });

            if (currentContractUser) {
              const appRoles = applicationRoles.map((r) => {
                if (r.ApplicationRoleId === "Mixed") {
                  const prevId =
                    currentContractUser.contract_user_application_role.find(
                      (ar) => {
                        return ar.ApplicationId === r.ApplicationId;
                      },
                    );
                  return { ...r, ApplicationRoleId: prevId?.ApplicationRoleId };
                }
                return r;
              });

              const editContractUser = new ContractUserCreateItem(
                currentContractUser.UserId,
                currentContractUser.ContractId,
                appRoles,
                currentContractUser.Guid,
              );

              console.log(
                "editContractUser ApplicationRoles",
                editContractUser.ApplicationRoles,
              );

              contractUsers.push(editContractUser);
            }
          });
          console.log(contractUsers);

          this.contractUserService.assignContractUsers(contractUsers).subscribe(
            (users) => {
              if (users) {
                this.back();
              }
            },
            (error: HttpErrorResponse) => {
              this.errorHandle(error);
            },
          );
        }
      }
    });
  }

  back(): void {
    this.router.navigate([`/contractUser/${this.contract.Guid}`]);
  }

  cancel(): void {
    this.close.emit();
  }

  onRoleChange(e: IMenuItem | IMenuItem[], i: number): void {
    if (e && !Array.isArray(e) && this.applicationList[i].value !== e.id) {
      this.applicationList[i].value = e.id;
      this.activeSaveChange.emit(true);
    }
  }

  removeUser(): void {
    const modalInstance = this.activeModal.open(NotificationComponent);
    modalInstance.instance.theme = "light";
    modalInstance.instance.title = "Notification";
    modalInstance.instance.body =
      "Are you sure you would like to remove this permission?";
    this.firstOpenChange.emit(true);
    modalInstance.result.then((result) => {
      if (result === 1) {
        this.disabledContract = true;
        this.activeSaveChange.emit(true);
      }
    });
  }

  errorHandle(error: HttpErrorResponse): void {
    this.loadingService.stop();
    const modalInstance = this.activeModal.open(NotificationComponent);
    modalInstance.instance.type = NotificationType.Information;
    modalInstance.instance.theme = "light";
    modalInstance.instance.title = "Your Changes Can't be Saved.";
    modalInstance.instance.body =
      "Error occurs. Please refresh your screen to see updates.";
    modalInstance.result.then((result) => {
      if (result === 0) {
        const currentUrl = this.router.url;
        this.router.navigateByUrl("blank").then(() => {
          this.router.navigateByUrl(currentUrl);
        });
      }
    });
  }
}
